import { useCallback } from 'react';
import { useCustomAlarmsListContext } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/hooks/use-custom-alarms-list-context/use-custom-alarms-list-context.hook';
import { useCustomAlarmConfirmationModal } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/hooks/use-custom-alarm-confirmation-modal/use-custom-alarm-confirmation-modal.hook';

export const useCustomAlarmsList = () => {
    const { customAlarms, isLoading, selectedRows, setSelectedRows, onlyActive, handleOnlyActiveChange } =
        useCustomAlarmsListContext();
    const { showDeleteConfirmationModal, showDeactivateConfirmationModal, showActivateConfirmationModal } =
        useCustomAlarmConfirmationModal();

    const handleOnSelectRow = useCallback(
        (alarmId: string, isSelected: boolean) => {
            const alarm = customAlarms.find((c) => c.id === alarmId);
            if (!alarm) {
                return;
            }

            setSelectedRows((prev) => (isSelected ? [...prev, alarm] : prev.filter((row) => row.id !== alarmId)));
        },
        [customAlarms, setSelectedRows]
    );

    const areAllActive: boolean = selectedRows.every((alarm) => alarm.active);

    const areAllInactive: boolean = selectedRows.every((alarm) => !alarm.active);

    return {
        customAlarms,
        isLoading,
        selectedRows,
        handleOnSelectRow,
        setSelectedRows,
        showDeleteConfirmationModal,
        areAllActive,
        areAllInactive,
        onlyActive,
        handleOnlyActiveChange,
        showDeactivateConfirmationModal,
        showActivateConfirmationModal,
    };
};
